/*global _ Vue */
import {inject} from '../dynamic'
import {promiseFactory} from '../utils'
import ReConfirm from '../../components/modals/re-confirm'
import ReAlert from '../../components/modals/re-alert'

const optionFactory = (message, title, options = {}) => {
  options = options || {}
  if (_.isObject(message)) {
    options = _.merge({}, message, options || {})
  } else {
    options.message = message || ' '
  }
  if (!_.isUndefined(title)) {
    if (_.isObject(title)) {
      options = _.merge({}, title, options || {})
    } else {
      options.title = title || options.title || ' '
    }
  }

  return options
}

const componentFactory = function (module, properties, defaultProps, skipProps) {
  skipProps = skipProps || ['slots', 'options', 'target', 'prepend', 'append', 'after']
  defaultProps = _.defaultsDeep(defaultProps, {
    title: null,
    message: null,
    noClose: false,
  })

  let targetElement = 'body'
  if (this instanceof Vue) {
    targetElement = this
  }

  const allProperties = {...defaultProps, ...properties || {}}
  const props = {config: {...defaultProps, ..._.omit(properties || {}, skipProps)}}
  const {slots, target = targetElement, options = {}, prepend, before, after} = allProperties
  Object.assign(options, {prepend, before, after})

  const component = inject(module, {slots, props, target, options})
  component.$on('close', () => {
    component.$el.remove()
    component.$destroy()
  })
  return component
}

export const alert = function (properties = {}) {
  const defaultProps = {
    title: null,
    message: '',
    noClose: false,
  }
  return componentFactory.call(this, ReAlert, properties, defaultProps)
}

export const alertAsync = function (message, title, type, options = {}) {
  options.type = type
  return promiseFactory.call(this, alert, optionFactory(message, title, options))
}

export const infoAlert = function (message, title, options = {}) {
  options.type = 'info'
  return alert.call(this, optionFactory(message, title, options))
}

export const infoAlertAsync = function (message, title, options = {}) {
  return alertAsync.call(this, message, title, 'info', options)
}

export const warningAlert = function (message, title, options = {}) {
  options.type = 'warning'
  return alert.call(this, optionFactory(message, title, options))
}

export const warningAlertAsync = function (message, title, options = {}) {
  return alertAsync.call(this, message, title, 'warning', options)
}

export const errorAlert = function (message, title, options = {}) {
  options.type = 'error'
  return alert.call(this, optionFactory(message, title, options))
}

export const errorAlertAsync = function (message, title, options = {}) {
  return alertAsync.call(this, message, title, 'danger', options)
}

export const successAlert = function (message, title, options = {}) {
  options.type = 'success'
  return alert.call(this, optionFactory(message, title, options))
}

export const successAlertAsync = function (message, title, options = {}) {
  return alertAsync.call(this, message, title, 'success', options)
}

export const confirm = function (properties = {}) {
  const defaultProps = {
    title: null,
    message: 'Do you want to continue',
    denyLabel: 'No',
    confirmLabel: 'Yes',
    noClose: false,
  }
  return componentFactory.call(this, ReConfirm, properties, defaultProps)
}

export const confirmAsync = async function (message, title, options = {}) {
  return promiseFactory.call(this, confirm, optionFactory(message, title, options))
}

export default {
  alert,
  alertAsync,
  confirm,
  confirmAsync,

  infoAlert,
  infoAlertAsync,
  successAlert,
  successAlertAsync,
  warningAlert,
  warningAlertAsync,
  errorAlert,
  errorAlertAsync,
}
